/**
 * @generated SignedSource<<4ef880d03999da37a0cf38227472ed0e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Contact_Node_Fragment$data = {
  readonly company: string | null | undefined;
  readonly country: string | null | undefined;
  readonly created: string | null | undefined;
  readonly databaseId: number | null | undefined;
  readonly email: string;
  readonly firstname: string | null | undefined;
  readonly formEntries: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly created: string | null | undefined;
        readonly form: {
          readonly node: {
            readonly content: string | null | undefined;
            readonly title: string;
          };
        } | null | undefined;
        readonly marketingConsent: boolean;
      };
    }>;
  } | null | undefined;
  readonly id: string;
  readonly ids: ReadonlyArray<string | null | undefined> | null | undefined;
  readonly jobTitle: string | null | undefined;
  readonly lastname: string | null | undefined;
  readonly modified: string | null | undefined;
  readonly " $fragmentType": "Contact_Node_Fragment";
};
export type Contact_Node_Fragment$key = {
  readonly " $data"?: Contact_Node_Fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"Contact_Node_Fragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "created",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Contact_Node_Fragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "databaseId",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "modified",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstname",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastname",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "company",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "country",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ids",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "jobTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ContactToFormEntriesConnection",
      "kind": "LinkedField",
      "name": "formEntries",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ContactToFormEntriesConnectionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "FormEntry",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "marketingConsent",
                  "storageKey": null
                },
                (v0/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "FormEntryToFormConnectionEdge",
                  "kind": "LinkedField",
                  "name": "form",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "Form",
                      "kind": "LinkedField",
                      "name": "node",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "title",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "content",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Contact",
  "abstractKey": null
};
})();

(node as any).hash = "388bf7cd4972f7e92320c1c2bc8067f3";

export default node;
